import { PropsWithChildren, memo } from 'react';
import { NodeType, TimelineNode } from '../types';
import { NodeEmpty } from './NodeEmpty';
import { NodeBreak } from './NodeBreak/NodeBreak';
import { NodeMultiple } from './NodeMultiple/NodeMultiple';
import { NodeSingle } from './NodeSingle/NodeSingle';
import { NodeBatch } from './NodeBatch/NodeBatch';
import { withDroppableArea } from './withDroppableArea';

export type NodeGanttProps = {
  node: TimelineNode;
  isQueueDisabled: boolean;
  nodes: TimelineNode[];
  index: number;
  queueId: number;
};

type GanttSwitchProps = {
  node: TimelineNode;
};

/**
 *
 * Remember to add children, because are passed from withDroppableArea
 */
const GanttSwitch = ({ node, children }: PropsWithChildren<GanttSwitchProps>) => {
  switch (node.type) {
    case NodeType.EMPTY: {
      return <NodeEmpty node={node}>{children}</NodeEmpty>;
    }
    case NodeType.BREAK: {
      return <NodeBreak node={node}>{children}</NodeBreak>;
    }
    case NodeType.MULTIPLE: {
      return <NodeMultiple node={node}>{children}</NodeMultiple>;
    }
    case NodeType.TASK: {
      return <NodeSingle node={node}>{children}</NodeSingle>;
    }
    case NodeType.BATCH: {
      return <NodeBatch node={node}>{children}</NodeBatch>;
    }
    default:
      return null;
  }
};

const DroppableNode = withDroppableArea(GanttSwitch);

export const NodeGantt = memo(({ node, nodes, index, isQueueDisabled, queueId }: NodeGanttProps) => {
  const previousNode = nodes.at(index - 1);
  const nextNode = nodes.at(index + 1);

  return (
    <DroppableNode
      isQueueDisabled={isQueueDisabled}
      nextNode={nextNode}
      node={node}
      previousNode={previousNode}
      queueId={queueId}
    />
  );
});

NodeGantt.displayName = 'QueueGanttNodeSingle';
